import { useRef, useState } from "react";

import { ChevronDownIcon } from "lucide-react";

import {
  Accordion,
  AccordionContent,
  AccordionTitle,
} from "simplydo/react/ui/accordion";
import { Icon } from "simplydo/react/ui/icon";

type BasicAccordionProps = {
  content: React.ReactNode;
  title: React.ReactNode;
  style?: React.CSSProperties;
};

const BasicAccordion = ({ content, title, style }: BasicAccordionProps) => {
  const [accordionIndex, setAccordionIndex] = useState(-1);

  const accordionRef = useRef<HTMLDivElement>(null);

  return (
    <Accordion style={style} ref={accordionRef}>
      <AccordionTitle
        active={accordionIndex === 0}
        index={0}
        onClick={(_e, titleProps) => {
          if (!titleProps) return;
          const { index } = titleProps;
          setAccordionIndex(accordionIndex === index ? -1 : (index as number));
          if (accordionRef.current) {
            accordionRef.current.scrollIntoView({ behavior: "smooth" });
          }
        }}
        style={{ marginBottom: 0, display: "flex", alignItems: "center" }}
      >
        {title}
      </AccordionTitle>
      <AccordionContent active={accordionIndex === 0} index={0}>
        {content}
      </AccordionContent>
    </Accordion>
  );
};

export default BasicAccordion;
